import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=dbb7d54e&scoped=true"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=dbb7d54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb7d54e",
  null
  
)

export default component.exports